import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'pfpax';
export const route = 'pfpax/[searchId]/[fareItineraryKey]/[segmentKeys]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "pfpax" */
/* webpackPrefetch: true */
'../components/PaxPage')));